module.exports = __webpack_public_path__ + "assets/img/txt-professionals-04.d59609ba.svg";